// The 11 primary service suburbs (with postcodes). Used across all public quote forms.
export const PRIMARY_SUBURBS = [
  { name: 'Albany Creek', postcode: '4035' },
  { name: 'Eatons Hill', postcode: '4037' },
  { name: 'Cashmere', postcode: '4500' },
  { name: 'Warner', postcode: '4500' },
  { name: 'Strathpine', postcode: '4500' },
  { name: 'Bray Park', postcode: '4500' },
  { name: 'Brendale', postcode: '4500' },
  { name: 'Petrie', postcode: '4502' },
  { name: 'Kallangur', postcode: '4503' },
  { name: 'Murrumba Downs', postcode: '4503' },
  { name: 'North Lakes', postcode: '4509' },
];

export const PRIMARY_SUBURB_NAMES = PRIMARY_SUBURBS.map((s) => s.name);

export const isPrimarySuburb = (s) =>
  PRIMARY_SUBURB_NAMES.some((n) => n.toLowerCase() === String(s || '').trim().toLowerCase());
